// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DuplicateCashflowMutationVariables = Types.Exact<{
  cashflowID: Types.Scalars['ID']['input'];
}>;


export type DuplicateCashflowMutation = { __typename?: 'Mutation', duplicateCashflow: { __typename?: 'Cashflow', id: string } };

export const Operations = {
  Mutation: {
    DuplicateCashflow: 'DuplicateCashflow' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DuplicateCashflowDocument = gql`
    mutation DuplicateCashflow($cashflowID: ID!) {
  duplicateCashflow(cashflowID: $cashflowID) {
    id
  }
}
    `;
export type DuplicateCashflowMutationFn = Apollo.MutationFunction<DuplicateCashflowMutation, DuplicateCashflowMutationVariables>;

/**
 * __useDuplicateCashflowMutation__
 *
 * To run a mutation, you first call `useDuplicateCashflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCashflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCashflowMutation, { data, loading, error }] = useDuplicateCashflowMutation({
 *   variables: {
 *      cashflowID: // value for 'cashflowID'
 *   },
 * });
 */
export function useDuplicateCashflowMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateCashflowMutation, DuplicateCashflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateCashflowMutation, DuplicateCashflowMutationVariables>(DuplicateCashflowDocument, options);
      }
export type DuplicateCashflowMutationHookResult = ReturnType<typeof useDuplicateCashflowMutation>;
export type DuplicateCashflowMutationResult = Apollo.MutationResult<DuplicateCashflowMutation>;
export type DuplicateCashflowMutationOptions = Apollo.BaseMutationOptions<DuplicateCashflowMutation, DuplicateCashflowMutationVariables>;